import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
// import Paper from '@material-ui/core/Paper';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  pageNav: {
    top: 64,
  },
}));


function PageContent(props) {
  const classes = useStyles();
  const { children } = props;
  const containerProps = {
    classes: { root: classes.container },
    component: 'main',
    maxWidth: false,
  };
  return (
    <Container {...containerProps}>
      <Grid item xs={12}>
        {children}
      </Grid>
    </Container>
  );
}

PageContent.propTypes = propTypes;

export default PageContent;
